// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui.header.page-header {
  margin-top: 6rem;
  margin-bottom: 2rem;
}
.ui.header.filtro-header {
  margin-bottom: 2rem;
}
.ui.form .datepicker-input .field .ui.icon.input input {
  width: 17rem;
}
/* Navbar */
.navbar__item--mobile {
  display: none !important;
}
.ui.menu.navbar__menu .item:before {
  width: 0;
}

/* Fatura Card */
.ui.card > .content.fatura__card__header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.ui.card > .content.fatura__card__header::after {
  display: none;
}
.fatura__card__column.fatura_card_column--radio {
  width: 25%;
}
.fatura__card__column {
  width: 21%;
}
.fatura__card__column span {
  line-height: 1.5rem;
}
.ui.form.fatura__card__radio {
  margin: 1rem 0;
}
.fatura__card__radio span {
  text-align: end;
}
.ui.form.fatura__card__radio .field {
  margin: 0;
}
.ui.form.fatura__card__radio label {
  font-weight: bold;
}

.consulta-table-scroll {
  width: 100%;
  max-height: 65vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

/* Keep headers sticky while scrolling vertically */
.consulta-table-scroll thead th {
  position: sticky;
  top: 0;
  z-index: 10;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table {
  min-width: 1360px;
  table-layout: auto !important;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table th,
.consulta-table-scroll .ui.table.consulta-comissoes-table td {
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
  vertical-align: middle;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(1),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(1) {
  min-width: 70px;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(2),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(2),
.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(3),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(3) {
  min-width: 190px;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(4),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(4),
.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(6),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(6),
.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(7),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(7) {
  min-width: 110px;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(5),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(5) {
  min-width: 160px;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(8),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(8),
.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(9),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(9),
.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(10),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(10),
.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(11),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(11) {
  min-width: 130px;
  font-variant-numeric: tabular-nums;
}

.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(12),
.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(12) {
  min-width: 150px;
}

.ui.fixed.menu.menu__selecionar-varias--deactive {
  display: none;
}
@media only screen and (max-width: 1000px) {
  /* Navbar */
  .navbar__item--pc {
    display: none !important;
  }

  .navbar--mobile {
    width: 50vw !important;
  }

  .navbar__item--mobile {
    display: flex !important;
  }

  .navbar__item--mobile--close {
    align-self: baseline;
    padding-left: 0 !important;
  }

  .navbar__item--mobile--close::before {
    background: none !important;
  }
  .dimmed-screen {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    margin: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .ui.form .datepicker-input .field .ui.icon.input input {
    width: 10rem;
  }
}

@media only screen and (max-width: 767px) {
  /* Navbar */
  .navbar__item--pc {
    display: none !important;
  }

  .navbar--mobile {
    width: 50vw !important;
  }

  .navbar__item--mobile {
    display: flex !important;
  }

  .navbar__item--mobile--close {
    align-self: baseline;
    padding-left: 0 !important;
  }

  .navbar__item--mobile--close::before {
    background: none !important;
  }
  .dimmed-screen {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    margin: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.3);
  }
  /* ----------------------- */
  .ui.form .datepicker-input .field .ui.icon.input input {
    width: 100%;
  }
  .datepicker-field,
  .datepicker-field .field {
    width: 100%;
  }
}

/* ========================================================= */
/*                   MODERN REDESIGN (V2)                    */
/* ========================================================= */

:root {
  --primary-gradient: linear-gradient(135deg, #0d71bb 0%, #00b5ad 100%);
  --secondary-gradient: linear-gradient(135deg, #00b5ad 0%, #0d71bb 100%);
  --border-radius: 20px;
  --box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  --glass-bg: rgba(255, 255, 255, 0.85);
  --glass-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
  --glass-border: 1px solid rgba(255, 255, 255, 0.18);
  --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  --background-color: #f4f7fb;
}

body {
  background-color: var(--background-color) !important;
}

/* =========================================
   CARDS & SEGMENTS
   ========================================= */
.ui.card, .ui.cards>.card {
  border-radius: var(--border-radius) !important;
  box-shadow: var(--box-shadow) !important;
  border: none !important;
  transition: var(--transition);
  background: var(--glass-bg);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.ui.segment {
  border-radius: var(--border-radius) !important;
  box-shadow: var(--box-shadow) !important;
  border: none !important;
}

/* =========================================
   BUTTONS
   ========================================= */
.ui.button {
  border-radius: 12px !important;
  font-weight: 600 !important;
  transition: var(--transition) !important;
  border: none !important;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1) !important;
}
.ui.button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0,0,0,0.15) !important;
}
/* Primary/Blue Buttons */
.ui.blue.button, .ui.primary.button {
  background: var(--primary-gradient) !important;
  color: white !important;
}
.ui.blue.button:hover, .ui.primary.button:hover {
  background: var(--secondary-gradient) !important;
  filter: brightness(1.1);
}
/* Red Buttons */
.ui.red.button, .ui.negative.button {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;
  color: white !important;
}

/* =========================================
   TABLES
   ========================================= */
.ui.table {
  border-radius: 15px !important;
  box-shadow: var(--box-shadow) !important;
  border: none !important;
}

.consulta-table-wrapper table {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;
  border: 1px solid #e0e0e0 !important;
  border-top: none !important;
}
.ui.table thead th {
  background: #0d71bb !important;
  color: white !important;
  border-bottom: none !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 0 !important;
}
.ui.table tbody tr:hover {
  background-color: rgba(0, 181, 173, 0.05) !important;
}
.ui.table td {
  border-top: 1px solid #f0f0f0 !important;
}

/* =========================================
   INPUTS & DROPDOWNS
   ========================================= */
.ui.input>input, .ui.selection.dropdown, .ui.dropdown .menu {
  border-radius: 12px !important;
  border: 1px solid #e0e0e0 !important;
  box-shadow: inset 0 1px 3px rgba(0,0,0,0.02) !important;
  transition: var(--transition) !important;
  cursor: pointer !important;
}
.ui.checkbox label, .datepicker-input input, .react-datepicker-wrapper input {
  cursor: pointer !important;
}
.ui.input>input:focus, .ui.selection.dropdown:focus {
  border-color: #00b5ad !important;
  box-shadow: 0 0 0 2px rgba(0, 181, 173, 0.2) !important;
}

/* =========================================
   MODALS
   ========================================= */
.ui.dimmer {
  background-color: rgba(0, 0, 0, 0.6) !important;
  -webkit-backdrop-filter: blur(5px) !important;
          backdrop-filter: blur(5px) !important;
}

/* =========================================
   MENUS / NAVBAR
   ========================================= */
.ui.menu {
  border-radius: 15px !important;
  box-shadow: var(--box-shadow) !important;
  border: none !important;
  background: var(--glass-bg) !important;
  -webkit-backdrop-filter: blur(10px) !important;
          backdrop-filter: blur(10px) !important;
}

/* Menu fixed (navbar) */
.ui.fixed.menu {
  border-radius: 0 !important;
  background: linear-gradient(135deg, #0d71bb 0%, #00b5ad 100%) !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
}
.ui.fixed.menu .item, .ui.fixed.menu .item>i.icon {
  color: white !important;
  font-weight: 500;
}
.ui.fixed.menu .item:hover {
  background: rgba(255,255,255,0.1) !important;
}
.ui.fixed.menu .item.no-hover:hover {
  background: transparent !important;
  cursor: default !important;
}
.ui.fixed.menu .active.item {
  background: rgba(255, 255, 255, 0.25) !important;
  color: white !important;
  border-radius: 8px !important;
  margin: 0.2rem 0 !important;
}

/* =========================================
   PAGINATION
   ========================================= */
.ui.pagination.menu {
  background: white !important;
}
.ui.pagination.menu .item.active {
  background: var(--primary-gradient) !important;
  color: white !important;
}

/* Fix action inputs (like password eye button) */
.ui.action.input > input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.ui.action.input > .button {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

/* Modern Status Headers */
.modern-status-header {
  padding: 12px 20px;
  border-radius: 12px 12px 0 0;
  color: white;
  transition: opacity 0.3s ease;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}
.modern-status-header:hover {
  opacity: 0.9;
}
.modern-status-header.status-quitadas {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}
.modern-status-header.status-avencer {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}
.modern-status-header.status-vencidas {
  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);
}

/* Overriding Chrome Autofill Yellow Background */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 50px white inset !important;
    -webkit-text-fill-color: #333 !important;
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s;
}

/* Custom class to force blue color on dropdown/sidebar icons */
.ui.menu .item i.icon.blue-icon,
.ui.menu .item .item i.icon.blue-icon,
i.icon.blue-icon {
  color: #0d71bb !important;
}

`, "",{"version":3,"sources":["webpack://./src/main/styles/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA,WAAW;AACX;EACE,wBAAwB;AAC1B;AACA;EACE,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,oCAAoC;EACtC;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,oCAAoC;EACtC;EACA,4BAA4B;EAC5B;IACE,WAAW;EACb;EACA;;IAEE,WAAW;EACb;AACF;;AAEA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qBAAqB;EACrB,0CAA0C;EAC1C,qCAAqC;EACrC,oDAAoD;EACpD,mDAAmD;EACnD,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;8CAE8C;AAC9C;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;;8CAE8C;AAC9C;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,wCAAwC;EACxC,uBAAuB;EACvB,iDAAiD;AACnD;AACA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;AACA,yBAAyB;AACzB;EACE,8CAA8C;EAC9C,uBAAuB;AACzB;AACA;EACE,gDAAgD;EAChD,uBAAuB;AACzB;AACA,gBAAgB;AAChB;EACE,wEAAwE;EACxE,uBAAuB;AACzB;;AAEA;;8CAE8C;AAC9C;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,0CAA0C;EAC1C,2CAA2C;EAC3C,gDAAgD;EAChD,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,oDAAoD;AACtD;AACA;EACE,wCAAwC;AAC1C;;AAEA;;8CAE8C;AAC9C;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,uDAAuD;EACvD,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;;8CAE8C;AAC9C;EACE,+CAA+C;EAC/C,6CAAqC;UAArC,qCAAqC;AACvC;;AAEA;;8CAE8C;AAC9C;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,uBAAuB;EACvB,sCAAsC;EACtC,8CAAsC;UAAtC,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;EAC3B,wEAAwE;EACxE,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;8CAE8C;AAC9C;EACE,4BAA4B;AAC9B;AACA;EACE,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;EACE,YAAY;AACd;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA,iDAAiD;AACjD;;;;IAII,qDAAqD;IACrD,wCAAwC;IACxC,yDAAiD;IAAjD,iDAAiD;AACrD;;AAEA,+DAA+D;AAC/D;;;EAGE,yBAAyB;AAC3B","sourcesContent":[".ui.header.page-header {\n  margin-top: 6rem;\n  margin-bottom: 2rem;\n}\n.ui.header.filtro-header {\n  margin-bottom: 2rem;\n}\n.ui.form .datepicker-input .field .ui.icon.input input {\n  width: 17rem;\n}\n/* Navbar */\n.navbar__item--mobile {\n  display: none !important;\n}\n.ui.menu.navbar__menu .item:before {\n  width: 0;\n}\n\n/* Fatura Card */\n.ui.card > .content.fatura__card__header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.ui.card > .content.fatura__card__header::after {\n  display: none;\n}\n.fatura__card__column.fatura_card_column--radio {\n  width: 25%;\n}\n.fatura__card__column {\n  width: 21%;\n}\n.fatura__card__column span {\n  line-height: 1.5rem;\n}\n.ui.form.fatura__card__radio {\n  margin: 1rem 0;\n}\n.fatura__card__radio span {\n  text-align: end;\n}\n.ui.form.fatura__card__radio .field {\n  margin: 0;\n}\n.ui.form.fatura__card__radio label {\n  font-weight: bold;\n}\n\n.consulta-table-scroll {\n  width: 100%;\n  max-height: 65vh;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Keep headers sticky while scrolling vertically */\n.consulta-table-scroll thead th {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table {\n  min-width: 1360px;\n  table-layout: auto !important;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table th,\n.consulta-table-scroll .ui.table.consulta-comissoes-table td {\n  white-space: nowrap;\n  overflow: visible;\n  text-overflow: clip;\n  vertical-align: middle;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(1),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(1) {\n  min-width: 70px;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(2),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(2),\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(3),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(3) {\n  min-width: 190px;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(4),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(4),\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(6),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(6),\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(7),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(7) {\n  min-width: 110px;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(5),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(5) {\n  min-width: 160px;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(8),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(8),\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(9),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(9),\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(10),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(10),\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(11),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(11) {\n  min-width: 130px;\n  font-variant-numeric: tabular-nums;\n}\n\n.consulta-table-scroll .ui.table.consulta-comissoes-table th:nth-child(12),\n.consulta-table-scroll .ui.table.consulta-comissoes-table td:nth-child(12) {\n  min-width: 150px;\n}\n\n.ui.fixed.menu.menu__selecionar-varias--deactive {\n  display: none;\n}\n@media only screen and (max-width: 1000px) {\n  /* Navbar */\n  .navbar__item--pc {\n    display: none !important;\n  }\n\n  .navbar--mobile {\n    width: 50vw !important;\n  }\n\n  .navbar__item--mobile {\n    display: flex !important;\n  }\n\n  .navbar__item--mobile--close {\n    align-self: baseline;\n    padding-left: 0 !important;\n  }\n\n  .navbar__item--mobile--close::before {\n    background: none !important;\n  }\n  .dimmed-screen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    z-index: 99;\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n  .ui.form .datepicker-input .field .ui.icon.input input {\n    width: 10rem;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  /* Navbar */\n  .navbar__item--pc {\n    display: none !important;\n  }\n\n  .navbar--mobile {\n    width: 50vw !important;\n  }\n\n  .navbar__item--mobile {\n    display: flex !important;\n  }\n\n  .navbar__item--mobile--close {\n    align-self: baseline;\n    padding-left: 0 !important;\n  }\n\n  .navbar__item--mobile--close::before {\n    background: none !important;\n  }\n  .dimmed-screen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    margin: 0;\n    z-index: 99;\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n  /* ----------------------- */\n  .ui.form .datepicker-input .field .ui.icon.input input {\n    width: 100%;\n  }\n  .datepicker-field,\n  .datepicker-field .field {\n    width: 100%;\n  }\n}\n\n/* ========================================================= */\n/*                   MODERN REDESIGN (V2)                    */\n/* ========================================================= */\n\n:root {\n  --primary-gradient: linear-gradient(135deg, #0d71bb 0%, #00b5ad 100%);\n  --secondary-gradient: linear-gradient(135deg, #00b5ad 0%, #0d71bb 100%);\n  --border-radius: 20px;\n  --box-shadow: 0 10px 30px rgba(0,0,0,0.08);\n  --glass-bg: rgba(255, 255, 255, 0.85);\n  --glass-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);\n  --glass-border: 1px solid rgba(255, 255, 255, 0.18);\n  --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  --background-color: #f4f7fb;\n}\n\nbody {\n  background-color: var(--background-color) !important;\n}\n\n/* =========================================\n   CARDS & SEGMENTS\n   ========================================= */\n.ui.card, .ui.cards>.card {\n  border-radius: var(--border-radius) !important;\n  box-shadow: var(--box-shadow) !important;\n  border: none !important;\n  transition: var(--transition);\n  background: var(--glass-bg);\n  backdrop-filter: blur(10px);\n}\n\n.ui.segment {\n  border-radius: var(--border-radius) !important;\n  box-shadow: var(--box-shadow) !important;\n  border: none !important;\n}\n\n/* =========================================\n   BUTTONS\n   ========================================= */\n.ui.button {\n  border-radius: 12px !important;\n  font-weight: 600 !important;\n  transition: var(--transition) !important;\n  border: none !important;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1) !important;\n}\n.ui.button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 15px rgba(0,0,0,0.15) !important;\n}\n/* Primary/Blue Buttons */\n.ui.blue.button, .ui.primary.button {\n  background: var(--primary-gradient) !important;\n  color: white !important;\n}\n.ui.blue.button:hover, .ui.primary.button:hover {\n  background: var(--secondary-gradient) !important;\n  filter: brightness(1.1);\n}\n/* Red Buttons */\n.ui.red.button, .ui.negative.button {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;\n  color: white !important;\n}\n\n/* =========================================\n   TABLES\n   ========================================= */\n.ui.table {\n  border-radius: 15px !important;\n  box-shadow: var(--box-shadow) !important;\n  border: none !important;\n}\n\n.consulta-table-wrapper table {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n  border-bottom-left-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;\n  border: 1px solid #e0e0e0 !important;\n  border-top: none !important;\n}\n.ui.table thead th {\n  background: #0d71bb !important;\n  color: white !important;\n  border-bottom: none !important;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-radius: 0 !important;\n}\n.ui.table tbody tr:hover {\n  background-color: rgba(0, 181, 173, 0.05) !important;\n}\n.ui.table td {\n  border-top: 1px solid #f0f0f0 !important;\n}\n\n/* =========================================\n   INPUTS & DROPDOWNS\n   ========================================= */\n.ui.input>input, .ui.selection.dropdown, .ui.dropdown .menu {\n  border-radius: 12px !important;\n  border: 1px solid #e0e0e0 !important;\n  box-shadow: inset 0 1px 3px rgba(0,0,0,0.02) !important;\n  transition: var(--transition) !important;\n  cursor: pointer !important;\n}\n.ui.checkbox label, .datepicker-input input, .react-datepicker-wrapper input {\n  cursor: pointer !important;\n}\n.ui.input>input:focus, .ui.selection.dropdown:focus {\n  border-color: #00b5ad !important;\n  box-shadow: 0 0 0 2px rgba(0, 181, 173, 0.2) !important;\n}\n\n/* =========================================\n   MODALS\n   ========================================= */\n.ui.dimmer {\n  background-color: rgba(0, 0, 0, 0.6) !important;\n  backdrop-filter: blur(5px) !important;\n}\n\n/* =========================================\n   MENUS / NAVBAR\n   ========================================= */\n.ui.menu {\n  border-radius: 15px !important;\n  box-shadow: var(--box-shadow) !important;\n  border: none !important;\n  background: var(--glass-bg) !important;\n  backdrop-filter: blur(10px) !important;\n}\n\n/* Menu fixed (navbar) */\n.ui.fixed.menu {\n  border-radius: 0 !important;\n  background: linear-gradient(135deg, #0d71bb 0%, #00b5ad 100%) !important;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;\n}\n.ui.fixed.menu .item, .ui.fixed.menu .item>i.icon {\n  color: white !important;\n  font-weight: 500;\n}\n.ui.fixed.menu .item:hover {\n  background: rgba(255,255,255,0.1) !important;\n}\n.ui.fixed.menu .item.no-hover:hover {\n  background: transparent !important;\n  cursor: default !important;\n}\n.ui.fixed.menu .active.item {\n  background: rgba(255, 255, 255, 0.25) !important;\n  color: white !important;\n  border-radius: 8px !important;\n  margin: 0.2rem 0 !important;\n}\n\n/* =========================================\n   PAGINATION\n   ========================================= */\n.ui.pagination.menu {\n  background: white !important;\n}\n.ui.pagination.menu .item.active {\n  background: var(--primary-gradient) !important;\n  color: white !important;\n}\n\n/* Fix action inputs (like password eye button) */\n.ui.action.input > input {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.ui.action.input > .button {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n/* Modern Status Headers */\n.modern-status-header {\n  padding: 12px 20px;\n  border-radius: 12px 12px 0 0;\n  color: white;\n  transition: opacity 0.3s ease;\n  box-shadow: 0 4px 6px rgba(0,0,0,0.1);\n}\n.modern-status-header:hover {\n  opacity: 0.9;\n}\n.modern-status-header.status-quitadas {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n}\n.modern-status-header.status-avencer {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n}\n.modern-status-header.status-vencidas {\n  background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%);\n}\n\n/* Overriding Chrome Autofill Yellow Background */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 50px white inset !important;\n    -webkit-text-fill-color: #333 !important;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\n/* Custom class to force blue color on dropdown/sidebar icons */\n.ui.menu .item i.icon.blue-icon,\n.ui.menu .item .item i.icon.blue-icon,\ni.icon.blue-icon {\n  color: #0d71bb !important;\n}\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
